import React, { useEffect, useState, Fragment } from 'react';
import { SearchOverlay } from './SearchOverlay';
export function Header() {
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMenuVisible, setIsMenuVisible] = useState(false);
  // Handle animation timing
  useEffect(() => {
    if (isMobileMenuOpen) {
      // Mount first, then animate in
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          setIsMenuVisible(true);
        });
      });
    } else {
      setIsMenuVisible(false);
    }
  }, [isMobileMenuOpen]);
  const handleCloseMenu = () => {
    setIsMenuVisible(false);
    // Wait for animation to finish before unmounting
    setTimeout(() => {
      setIsMobileMenuOpen(false);
    }, 300);
  };
  return <>
      <header className="w-full bg-white border-b border-light relative z-50" data-id="element-79">
        <div className="site-container py-4 lg:py-5 flex items-center justify-between" data-id="element-80">
          {/* LEFT: Communicate Logo + Adweek Logo */}
          <div className="flex items-end gap-3 lg:gap-5 flex-shrink min-w-0" data-id="element-81">
            <a href="#" className="flex-shrink min-w-0" data-id="element-82">
              <img src="https://cdn.magicpatterns.com/uploads/jXZbuP4JpR1bBw61Qwmybj/com-logo-left.png" alt="Communicate - The Marketing and Advertising Resource" className="object-contain h-auto w-[180px] sm:w-[240px] md:w-[320px] lg:w-[380px] xl:w-[420px]" data-id="element-83" />
            </a>
            <div className="hidden md:flex items-end flex-shrink-0" data-id="element-84">
              <img src="https://cdn.magicpatterns.com/uploads/9oPa9oho8n1be9KWvjUJbG/adweek-logo.svg" alt="In Association With Adweek" className="object-contain h-auto w-[120px] lg:w-[150px] xl:w-[185px]" data-id="element-85" />
            </div>
          </div>

          {/* RIGHT: Nav Links + Search */}
          <div className="hidden xl:flex items-center gap-2" data-id="element-86">
            <nav className="flex items-center leading-none" data-id="element-87">
              {['News', 'Brands', 'Agencies', 'Focus', 'Editions', 'Ranking'].map((item, index, array) => <Fragment key={item} data-id="element-88">
                  <a href={`#${item.toLowerCase()}`} className="hover:opacity-70 transition-opacity" style={{
                color: '#000',
                fontFamily: 'Poppins, sans-serif',
                fontSize: '1.125rem',
                fontStyle: 'normal',
                fontWeight: 400,
                lineHeight: 'normal',
                letterSpacing: '2px',
                textTransform: 'uppercase' as const
              }} data-id="element-89">
                    {item}
                  </a>
                  {index < array.length - 1 && <span className="mx-2 lg:mx-3" style={{
                color: '#000',
                fontFamily: 'Poppins, sans-serif',
                fontSize: '1.125rem',
                fontWeight: 400,
                lineHeight: 'normal',
                letterSpacing: '2px'
              }} data-id="element-90">
                      I
                    </span>}
                </Fragment>)}
            </nav>
            <button onClick={() => setIsSearchOpen(true)} className="flex items-center justify-center hover:opacity-70 transition-opacity ml-4" data-id="element-91">
              <img src="https://cdn.magicpatterns.com/uploads/kefk4zoRzRT9bCCZWToHjo/search_10025455_1.svg" alt="Search" className="w-6 h-6" data-id="element-92" />
            </button>
          </div>

          {/* Mobile controls */}
          <div className="flex items-center gap-4 xl:hidden" data-id="element-93">
            <button onClick={() => setIsSearchOpen(true)} className="flex items-center justify-center hover:opacity-70 transition-opacity" data-id="element-94">
              <img src="https://cdn.magicpatterns.com/uploads/kefk4zoRzRT9bCCZWToHjo/search_10025455_1.svg" alt="Search" className="w-5 h-5" data-id="element-95" />
            </button>
            <button className="hover:opacity-70 transition-opacity" onClick={() => setIsMobileMenuOpen(true)} style={{
            color: '#000000'
          }} data-id="element-96">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6" data-id="element-97">
                <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" data-id="element-98" />
              </svg>
            </button>
          </div>
        </div>
      </header>

      {/* Full-screen Mobile Menu with animation */}
      {isMobileMenuOpen && <div className="fixed inset-0 z-[100] flex flex-col" style={{
      backgroundColor: '#FFFFFF'
    }} data-id="element-99">
          {/* Mobile Menu Header */}
          <div className="flex items-center justify-between px-4 py-4" data-id="element-100">
            <a href="#" className="flex-shrink-0" onClick={handleCloseMenu} data-id="element-101">
              <img src="https://cdn.magicpatterns.com/uploads/jXZbuP4JpR1bBw61Qwmybj/com-logo-left.png" alt="Communicate" className="object-contain h-auto w-[180px] sm:w-[240px]" data-id="element-102" />
            </a>
            <button onClick={handleCloseMenu} className="hover:opacity-70 transition-opacity" style={{
          color: '#000000'
        }} data-id="element-103">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-7 h-7" data-id="element-104">
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" data-id="element-105" />
              </svg>
            </button>
          </div>

          {/* Mobile Nav Links - staggered fade in */}
          <nav className="flex-1 flex flex-col items-center justify-center gap-8" data-id="element-106">
            {['News', 'Brands', 'Agencies', 'Focus', 'Editions', 'Ranking'].map((item, index) => <a key={item} href={`#${item.toLowerCase()}`} onClick={handleCloseMenu} className="hover:opacity-70 transition-all" style={{
          color: '#000',
          fontFamily: 'Poppins, sans-serif',
          fontSize: '20px',
          fontStyle: 'normal',
          fontWeight: 400,
          lineHeight: 'normal',
          letterSpacing: '2px',
          textTransform: 'uppercase' as const,
          opacity: isMenuVisible ? 1 : 0,
          transform: isMenuVisible ? 'translateY(0)' : 'translateY(12px)',
          transition: `opacity 0.3s ease-out ${0.05 + index * 0.05}s, transform 0.3s ease-out ${0.05 + index * 0.05}s`
        }} data-id="element-107">
                  {item}
                </a>)}
          </nav>

          {/* Mobile Menu Footer - Adweek logo matching header size */}
          <div className="flex items-center justify-center pb-8" style={{
        opacity: isMenuVisible ? 1 : 0,
        transform: isMenuVisible ? 'translateY(0)' : 'translateY(8px)',
        transition: 'opacity 0.3s ease-out 0.4s, transform 0.3s ease-out 0.4s'
      }} data-id="element-108">
            <img src="https://cdn.magicpatterns.com/uploads/9oPa9oho8n1be9KWvjUJbG/adweek-logo.svg" alt="Adweek" className="object-contain h-auto w-[180px]" data-id="element-109" />
          </div>
        </div>}

      <SearchOverlay isOpen={isSearchOpen} onClose={() => setIsSearchOpen(false)} data-id="element-110" />
    </>;
}